@if (value) {
  <div class="mc-table-item">
    @if (!!value!.title) {
      <h4 class="mc-table-title">{{ value!.title }}</h4>
    }
    <table class="table">
      <thead>
        @if (rowHeaders) {
          <tr class="mc-header-row">
            @for (col of rowHeaders; track col) {
              <th class="mc-col-header-cell" [innerHTML]="col | safeHtml"></th>
            }
          </tr>
        }
      </thead>
      <tbody>
        @for (row of innerData; track row; let i = $index) {
          <tr class="mc-data-row">
            @if (columnHeaders) {
              <th class="mc-row-header-cell" [innerHTML]="columnHeaders[i]"></th>
            }
            @for (col of row; track col) {
              <td [innerHTML]="col | updateLink"></td>
            }
          </tr>
        }
      </tbody>
    </table>
    @if (value!.source) {
      <span class="attribution"> Source: <span class="source" [innerHTML]="value!.source"></span> </span>
    }
  </div>
}
